import HttpService from '../services/HttpService'
import UserService from '../services/UserService'
import { useRef, useState } from 'react'

const fieldClass =
    'mt-1.5 block h-11 w-full rounded-lg border border-slate-200 bg-white px-3 text-sm text-slate-900 shadow-sm outline-none ring-0 placeholder:text-slate-400 focus:border-brand-500 focus:ring-1 focus:ring-brand-500'

export default function SignUp() {
    const [nombre, setNombre] = useState('')
    const [apellidos, setApellidos] = useState('')
    const [correo, setCorreo] = useState('')
    const [password, setPassword] = useState('')
    const [confirmacion, setConfirmacion] = useState('')
    const [validateCorreoError, setValidateCorreoError] = useState()
    const [validateConfirmacionError, setValidateConfirmacionError] = useState()
    const [userCreated, setUserCreated] = useState(false)
    const [submitting, setSubmitting] = useState(false)
    const [submitError, setSubmitError] = useState('')
    const validForm = useRef(true)

    const isEmail = (email) => /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email)

    const guardarEmpresa = (e) => {
        e.preventDefault()
        validateForm()
        if (!validForm.current || submitting) return
        setSubmitting(true)
        setSubmitError('')
        HttpService.getAxiosClientRegistro()
            .post('/empresas', { nombre, apellidos, correo, password })
            .then(() => setUserCreated(true))
            .catch((err) => {
                const message =
                    err.response?.data?.message ||
                    err.response?.data?.error ||
                    'No se pudo crear la cuenta. Inténtalo de nuevo.'
                setSubmitError(typeof message === 'string' ? message : 'No se pudo crear la cuenta. Inténtalo de nuevo.')
            })
            .finally(() => setSubmitting(false))
    }

    const validateForm = () => {
        validForm.current = true
        if (!isEmail(correo)) {
            setValidateCorreoError('Debe ingresar un correo válido')
            validForm.current = false
        } else {
            setValidateCorreoError(null)
        }
        if (password !== confirmacion) {
            setValidateConfirmacionError('Las contraseñas no coinciden')
            validForm.current = false
        } else {
            setValidateConfirmacionError(null)
        }
    }

    const goLogin = (e) => {
        e.preventDefault()
        window.history.replaceState('', '', '/')
        UserService.doLogin()
    }

    return (
        <div className="flex min-h-screen items-center justify-center bg-slate-100 px-4 py-10">
            <div className="w-full max-w-md overflow-hidden rounded-2xl border border-slate-200 bg-white px-8 py-8 shadow-sm sm:px-10">
                    <a href="/">
                        <img className="h-10 w-auto" src="gotpay.svg" alt="GotPay" />
                    </a>
                    <h1 className="mt-6 text-xl font-semibold text-slate-900">Crea tu cuenta y cobra con CoDi</h1>
                    <p className="mt-1 text-sm text-slate-500">Sin comisiones. En minutos.</p>

                    {!userCreated ? (
                        <form onSubmit={guardarEmpresa} className="mt-6 space-y-4">
                            <fieldset disabled={submitting} className="space-y-4 disabled:opacity-70">
                            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                                <div>
                                    <label htmlFor="nombre" className="text-sm font-medium text-slate-700">Nombres</label>
                                    <input
                                        id="nombre"
                                        required
                                        type="text"
                                        autoComplete="given-name"
                                        className={fieldClass}
                                        value={nombre}
                                        onChange={(e) => setNombre(e.target.value)}
                                    />
                                </div>
                                <div>
                                    <label htmlFor="apellidos" className="text-sm font-medium text-slate-700">Apellidos</label>
                                    <input
                                        id="apellidos"
                                        required
                                        type="text"
                                        autoComplete="family-name"
                                        className={fieldClass}
                                        value={apellidos}
                                        onChange={(e) => setApellidos(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div>
                                <label htmlFor="email" className="text-sm font-medium text-slate-700">Correo</label>
                                <input
                                    id="email"
                                    required
                                    type="email"
                                    autoComplete="email"
                                    className={fieldClass}
                                    value={correo}
                                    onChange={(e) => {
                                        setCorreo(e.target.value)
                                        setValidateCorreoError(null)
                                    }}
                                />
                                {validateCorreoError && <p className="mt-1 text-xs text-rose-600">{validateCorreoError}</p>}
                            </div>
                            <div>
                                <label htmlFor="password" className="text-sm font-medium text-slate-700">Contraseña</label>
                                <input
                                    id="password"
                                    required
                                    type="password"
                                    autoComplete="new-password"
                                    className={fieldClass}
                                    value={password}
                                    onChange={(e) => {
                                        setPassword(e.target.value)
                                        setValidateConfirmacionError(null)
                                    }}
                                />
                            </div>
                            <div>
                                <label htmlFor="password-confirm" className="text-sm font-medium text-slate-700">Confirmar contraseña</label>
                                <input
                                    id="password-confirm"
                                    required
                                    type="password"
                                    autoComplete="new-password"
                                    className={fieldClass}
                                    value={confirmacion}
                                    onChange={(e) => {
                                        setConfirmacion(e.target.value)
                                        setValidateConfirmacionError(null)
                                    }}
                                />
                                {validateConfirmacionError && (
                                    <p className="mt-1 text-xs text-rose-600">{validateConfirmacionError}</p>
                                )}
                            </div>
                            <button
                                type="submit"
                                disabled={submitting}
                                className="inline-flex h-11 w-full items-center justify-center gap-2 rounded-lg bg-brand-600 text-sm font-semibold text-white hover:bg-brand-700 disabled:cursor-not-allowed disabled:opacity-70"
                            >
                                {submitting && (
                                    <svg className="h-4 w-4 animate-spin" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z" />
                                    </svg>
                                )}
                                {submitting ? 'Creando tu cuenta…' : 'Crear cuenta'}
                            </button>
                            {submitError && <p className="text-center text-sm text-rose-600">{submitError}</p>}
                            <p className="text-center text-sm text-slate-500">
                                ¿Ya tienes cuenta?{' '}
                                <button type="button" onClick={goLogin} className="font-semibold text-brand-700 hover:text-brand-800">
                                    Inicia sesión
                                </button>
                            </p>
                            </fieldset>
                        </form>
                    ) : (
                        <div className="mt-8 rounded-xl border border-emerald-200 bg-emerald-50 p-5">
                            <p className="font-semibold text-emerald-900">Registro creado con éxito</p>
                            <p className="mt-2 text-sm text-emerald-800">Ya puedes acceder al panel con tu cuenta.</p>
                            <button type="button" onClick={goLogin} className="mt-4 font-semibold text-brand-700">
                                Acceder →
                            </button>
                        </div>
                    )}
            </div>
        </div>
    )
}
